import { FlowStepRuleFunctionVariadic } from '../flow-engine';

export const rule: FlowStepRuleFunctionVariadic = async function rule(_apiContext) {
  return true;
};
